var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8710)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8710)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#04AAC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#23C840"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66675 5.33337C5.07803 5.33337 5.46031 5.20923 5.77817 4.99637C5.74135 4.99881 5.70419 5.00004 5.66675 5.00004C4.74627 5.00004 4.00008 4.25385 4.00008 3.33337C4.00008 2.4129 4.74627 1.66671 5.66675 1.66671C5.70419 1.66671 5.74135 1.66794 5.77817 1.67037C5.46031 1.45752 5.07803 1.33337 4.66675 1.33337C3.56218 1.33337 2.66675 2.2288 2.66675 3.33337C2.66675 4.43794 3.56218 5.33337 4.66675 5.33337ZM8.00008 4.66671C8.00008 5.0349 7.7016 5.33337 7.33341 5.33337C6.96522 5.33337 6.66675 5.0349 6.66675 4.66671C6.66675 4.29852 6.96522 4.00004 7.33341 4.00004C7.7016 4.00004 8.00008 4.29852 8.00008 4.66671ZM10.0001 2.66671C10.3683 2.66671 10.6667 2.36823 10.6667 2.00004C10.6667 1.63185 10.3683 1.33337 10.0001 1.33337C9.63189 1.33337 9.33341 1.63185 9.33341 2.00004C9.33341 2.36823 9.63189 2.66671 10.0001 2.66671ZM13.3334 2.00004C13.3334 2.36823 13.0349 2.66671 12.6667 2.66671C12.2986 2.66671 12.0001 2.36823 12.0001 2.00004C12.0001 1.63185 12.2986 1.33337 12.6667 1.33337C13.0349 1.33337 13.3334 1.63185 13.3334 2.00004ZM12.6667 5.33337C13.0349 5.33337 13.3334 5.0349 13.3334 4.66671C13.3334 4.29852 13.0349 4.00004 12.6667 4.00004C12.2986 4.00004 12.0001 4.29852 12.0001 4.66671C12.0001 5.0349 12.2986 5.33337 12.6667 5.33337ZM10.6667 4.66671C10.6667 5.0349 10.3683 5.33337 10.0001 5.33337C9.63189 5.33337 9.33341 5.0349 9.33341 4.66671C9.33341 4.29852 9.63189 4.00004 10.0001 4.00004C10.3683 4.00004 10.6667 4.29852 10.6667 4.66671Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryUz);
export default __webpack_public_path__ + "static/media/Country=UZ.874d66944c68834167b03e733452dada.svg";
export { ForwardRef as ReactComponent };